// extracted by mini-css-extract-plugin
export default {"container":"ServiciosValue_container__re-9B","overlay":"ServiciosValue_overlay__a98Ni","subtitle":"ServiciosValue_subtitle__OUF2K","text":"ServiciosValue_text__EHw5w"};